import type { RecordingPingTelemetry } from '@/shared/api/transcriptor';

import { PingTelemetrySources } from './types';

/**
 * Snapshot of the capture pipeline for the activity ping. Pure so the
 * payload shape can be unit-tested without a MediaRecorder; the service
 * gathers the sources on each tick.
 */
export const buildPingTelemetry = ({
  track,
  recorderState,
  peakLevel,
  lastSignalTimestamp,
  chunkIndex,
  now,
  performanceNow,
  pageVisibility,
}: PingTelemetrySources): RecordingPingTelemetry => {
  const telemetry: RecordingPingTelemetry = {
    chunk_index: chunkIndex,
    performance_now_ms: performanceNow,
    wall_clock_ms: now,
  };

  if (track) {
    telemetry.track_ready_state = track.readyState;
    telemetry.track_muted = track.muted;
    telemetry.track_enabled = track.enabled;
  }
  if (recorderState) {
    telemetry.recorder_state = recorderState;
  }
  if (peakLevel !== null) {
    telemetry.peak_level = peakLevel;
  }
  if (lastSignalTimestamp > 0) {
    telemetry.seconds_since_signal = Math.max(
      0,
      (now - lastSignalTimestamp) / 1000,
    );
  }
  if (pageVisibility) {
    telemetry.page_visibility = pageVisibility;
  }

  return telemetry;
};
